import { Layout, Page } from "@fdoh/health-ui-react";
import AbandonmentForm from "../Components/AbandonmentForm";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";
import { useHistory, useLocation } from "react-router-dom";


// TODO: Add error handling

const CreateAbandonmentPage = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
    const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');
  return applicationId ? (
      <Page.Container>
          <ApplicationDetailsPage id={parseInt(applicationId)}></ApplicationDetailsPage>      
      <Page.Body>
        <Layout.Container>
                  <AbandonmentForm
                      id="AbandonmentForm"
                      title="Abandonment Inspection"
            action="post"
            applicationId={applicationId ? applicationId : 0}
            applicationInspectionId={inspectionId ? inspectionId : 0}
            returnPath={`/inspectionDetails/${inspectionId}`}
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ): <div>
    
  </div>;
};

export default CreateAbandonmentPage;